$(document).ready(function() {

	// banner select

	$('.s-value').each(function() {
		$(this).on('click', function(e) {
			// e.preventDefault();
			$('.selected-input').attr('value', $(this).text());
			$('.banner-item__btn a').attr('href', $(this).attr('href'));
			$(".custom-select-wr").hide();
			setTimeout(() => {
				$('.selected-input').attr('value', '');
			}, 400);
		})
	})

	$(document).mouseup(function(e) {
		var container = $(".custom-select-wr");
		var input = $(".selected-input-wr")[0];
		if (e.target == input) {
			container.toggle();
			// $('body').removeClass('open-select-menu');
		} else {
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				container.hide();
				$('body').removeClass('open-select-menu');
			}
		}
	});

	$('.selected-input-wr').on('click', function() {
		if ($('body').hasClass('open-select-menu')) {
			$('body').removeClass('open-select-menu');
		} else {  
			$('body').addClass('open-select-menu');
		}
	})

	$('.custom-select-wr__close').on('click', function() {
		$(".custom-select-wr").hide();
		$('body').removeClass('open-select-menu');
	})

	// close collapse
	jQuery('.collapse').on('show.bs.collapse', function() {
		jQuery('.collapse').removeClass('in').prev().attr('aria-expanded', false);
	});

	// close banner drop menu on scroll
	// $(window).on("scroll", closeDrop);

	// function closeDrop() {
	// 	if ($(window).scrollTop() > 20) {
	// 		$(".custom-select-wr").hide();
	// 	}
	// }

});